import { Alert, Badge, Box, Button, InfoIcon, Text } from '@razorpay/blade/components';
import { PFRegistrationStatus } from 'api/employeeOnboarding';
import { portalStatus } from '../data';
import { routePaths } from 'components/Routes/data';
import { useUserId } from 'components/EmployeeDetails/BankAccountDetails/hooks/useUserId';
import React from 'react';
import { prepareUrlV2 } from 'utils/Urls';
import { PortalStatus } from '../types';

export const PFRegistrationStatusInfo = ({
  pfStatus,
  pfRegistrationStatus,
}: {
  pfStatus?: PortalStatus | null;
  pfRegistrationStatus?: PFRegistrationStatus;
}) => {
  const userId = useUserId();

  if (pfStatus === portalStatus.exit) {
    return (
      <Alert
        color="information"
        isDismissible={false}
        description={`Log into the PF portal with admin credentials, find the employee, update their status to "Exit" or "Resigned," and enter the correct exit date.`}
        icon={InfoIcon}
        actions={{
          secondary: {
            text: 'Learn More',
            href: 'https://razorpay.com/docs/payroll/provident-fund#3-employee-registration-on-epfo',
            target: '_blank',
          },
        }}
      />
    );
  }

  if (pfStatus === portalStatus.notRegistered) {
    if (pfRegistrationStatus === 'Registration Failed') {
      return (
        <Box display="flex" gap="spacing.2" flexDirection="column">
          <Text color="surface.text.gray.muted" weight="semibold">
            Registration Status
          </Text>
          <Badge icon={InfoIcon} color="negative">
            Failed
          </Badge>
          <Button
            marginTop="spacing.6"
            variant="secondary"
            href={routePaths.reports.pfRegistrationDashboard}
            target="_blank">
            PF Registration Report
          </Button>
        </Box>
      );
    }

    if (pfRegistrationStatus === 'Registration Pending') {
      return (
        <Box display="flex" gap="spacing.2" flexDirection="column">
          <Text color="surface.text.gray.muted" weight="semibold">
            Registration Status
          </Text>
          <Badge color="information">In Progress</Badge>
        </Box>
      );
    }

    return (
      <>
        <Alert
          isDismissible={false}
          color="negative"
          description="PF payments for this employee cannot be processed without completing their registration. Ensure registration is completed to avoid any compliance issues"
        />
        <Button
          variant="secondary"
          href={prepareUrlV2('/addPf', {
            userId: userId,
          })}
          target="_blank">
          Provident Fund Registration
        </Button>
      </>
    );
  }

  return null;
};
